import React from 'react';
import cx from 'classnames';

import {Container} from 'reactstrap';

import styles from './Section.module.scss';

function Section(props) {
  const {
    children,
    className,
    light,
    grid,
    circle,
    padded,
    gradient,
    outline,
    removePad,
    mobilePad,
    ...rest
  } = props;

  const paddingRemove = cx({
    [styles[`section--no-pad-${removePad}`]]: !!removePad,
  });

  const paddingMobile = cx({
    [styles[`section--no-pad-${mobilePad}-mobile`]]: !!mobilePad,
  });

  return (
    <div
      className={cx(
        styles['section'],
        {
          [styles['section--light']]: light && !grid,
          [styles['section--grid']]: !light && grid,
          [styles['section--grid-light']]: light && grid,
          [styles['section--circle']]: circle,
          [styles['section--padded']]: padded,
          [styles['section--gradient']]: gradient,
          [styles['section--padded-outline']]: outline,
        },
        paddingRemove,
        paddingMobile,
        className
      )}
      {...rest}
    >
      <Container className={styles['section--container']}>{children}</Container>
    </div>
  );
}

Section.defaultProps = {
  light: false,
  grid: false,
};

export default Section;
